import React from "react";
import { MdClose, MdSave, MdCancel, MdPhoto } from "react-icons/md";
import Modal from "components/modal";

const FormModal = ({
  isOpen,
  onClose,
  title,
  onSubmit,
  isSubmitting,
  submitText = "Enregistrer",
  updateText = "Mettre à jour",
  isUpdate = false,
  children
}) => {
  const formContent = (
    <>
      {/* En-tête du formulaire */}
      <div className="mb-5 border-b border-gray-200 pb-5">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-[#333333]">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="rounded-full bg-gray-200 p-1 text-gray-500 transition-colors hover:bg-gray-300"
            aria-label="Fermer"
          >
            <MdClose size={20} />
          </button>
        </div>
      </div>

      {/* Corps du formulaire */}
      <form onSubmit={onSubmit} className="space-y-5">
        {children}

        {/* Boutons du formulaire */}
        <div className="mt-8 flex justify-end space-x-3 border-t pt-5">
          <button
            type="button"
            onClick={onClose}
            className="flex items-center rounded-md border border-gray-300 bg-white px-5 py-2 text-gray-700 transition-colors duration-200 hover:bg-gray-100"
          >
            <MdCancel className="mr-2" /> Annuler
          </button>

          <button
            type="submit"
            className="flex items-center justify-center rounded-md bg-gradient-to-r from-[#2ca01c] to-[#238615] px-5 py-2 text-white shadow-sm transition-all duration-200 hover:from-[#238615] hover:to-[#1c6e11] hover:shadow-lg"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <svg
                  className="mr-2 h-5 w-5 animate-spin text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
                Traitement...
              </>
            ) : (
              <>
                <MdSave className="mr-2" />
                {isUpdate ? updateText : submitText}
              </>
            )}
          </button>
        </div>
      </form>
    </>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="2xl">
      {formContent}
    </Modal>
  );
};

export default FormModal;